export var DirTypeEnum;
(function (DirTypeEnum) {
    DirTypeEnum[DirTypeEnum["forward"] = 0] = "forward";
    DirTypeEnum[DirTypeEnum["back"] = 1] = "back";
    DirTypeEnum[DirTypeEnum["both"] = 2] = "both";
    DirTypeEnum[DirTypeEnum["none"] = 3] = "none";
})(DirTypeEnum || (DirTypeEnum = {}));
//# sourceMappingURL=dirTypeEnum.js.map